<template>
    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-01.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0001</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Adrian</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>11 Nov 2024 10.45 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Video Call</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>adran@example.com</li>
                    <li><i class="fa-solid fa-phone"></i>+1 504 368 6874</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-02.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0002</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Kelly</router-link><span class="badge new-tag">New</span>
                        </h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>05 Nov 2024 11.50 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Audio Call</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>kelly@example.com</li>
                    <li><i class="fa-solid fa-phone"></i> +1 832 891 8403</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-03.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0003</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Samuel</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>27 Oct 2024 09.30 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Video Call</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>samuel@example.com</li>
                    <li><i class="fa-solid fa-phone"></i>  +1 749 104 6291</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-04.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0004</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Catherine</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>18 Oct 2024 12.20 PM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Direct Visit</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>catherine@example.com</li>
                    <li><i class="fa-solid fa-phone"></i>+1 584 920 7183</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-05.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0005</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Robert</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>10 Oct 2024 11.30 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Chat</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>robert@example.com</li>
                    <li><i class="fa-solid fa-phone"></i> +1 059 327 6729</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-06.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0006</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Anderea</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>26 Sep 2024 10.20 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Chat</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>anderea@example.com</li>
                    <li><i class="fa-solid fa-phone"></i>  +1 278 402 7103</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-07.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0007</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Peter</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>14 Sep 2024 08.10 AM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Chat</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>peter@example.com</li>
                    <li><i class="fa-solid fa-phone"></i> +1 638 278 0249</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Appointment List -->
    <div class="appointment-wrap">
        <ul>
            <li>
                <div class="patinet-information">
                    <router-link to="/doctor-upcoming-appointment">
                        <img src="@/assets/img/doctors-dashboard/profile-08.jpg" alt="User Image">
                    </router-link>
                    <div class="patient-info">
                        <p>#Apt0008</p>
                        <h6><router-link to="/doctor-upcoming-appointment">Emily</router-link></h6>
                    </div>
                </div>
            </li>
            <li class="appointment-info">
                <p><i class="fa-solid fa-clock"></i>03 Sep 2024 06.00 PM</p>
                <ul class="d-flex apponitment-types">
                    <li>General Visit</li>
                    <li>Video Call</li>
                </ul>

            </li>
            <li class="mail-info-patient">
                <ul>
                    <li><i class="fa-solid fa-envelope"></i>emily@example.com</li>
                    <li><i class="fa-solid fa-phone"></i>  +1 261 039 1873</li>
                </ul>
            </li>
            <li class="appointment-action">
                <ul>
                    <li>
                        <router-link to="/doctor-upcoming-appointment"><i class="fa-solid fa-eye"></i></router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-comments"></i></a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"><i class="fa-solid fa-xmark"></i></a>
                    </li>
                </ul>
            </li>
            <li class="appointment-start">
                <router-link to="/doctor-appointment-start" class="start-link">Start Now</router-link>
            </li>
        </ul>
    </div>
    <!-- /Appointment List -->

    <!-- Pagination -->
    <div class="pagination dashboard-pagination">
        <ul>
            <li>
                <a href="" class="page-link"><i class="fa-solid fa-chevron-left"></i></a>
            </li>
            <li>
                <a href="" class="page-link">1</a>
            </li>
            <li>
                <a href="" class="page-link active">2</a>
            </li>
            <li>
                <a href="" class="page-link">3</a>
            </li>
            <li>
                <a href="" class="page-link">4</a>
            </li>
            <li>
                <a href="" class="page-link">...</a>
            </li>
            <li>
                <a href="" class="page-link"><i class="fa-solid fa-chevron-right"></i></a>
            </li>
        </ul>
    </div>
    <!-- /Pagination -->
</template>